import getDistanceFromLatLonInKm from '@helpers/misc/coordinatesDistance'

import {RECALCULATE_ROUTE_EVERY_X_KM} from './constants'

let lastRouteStartingPoint = null

export default function getRoute(
  mapkit,
  pointA: {lat: number; lng: number},
  pointB: {lat: number; lng: number},
  opts = {},
  onAddOverlays: (overlays: any[]) => void = () => {}
) {
  if (
    lastRouteStartingPoint &&
    getDistanceFromLatLonInKm(
      lastRouteStartingPoint.lat,
      lastRouteStartingPoint.lng,
      pointA.lat,
      pointA.lng
    ) < RECALCULATE_ROUTE_EVERY_X_KM
  ) {
    // Don't recalculate the route if the starting point is too close to the previous one
    // This is to prevent running out of API calls (max 25000 per day)
    return
  }
  lastRouteStartingPoint = pointA

  // Returns a route between two points
  const directions = new mapkit.Directions()
  directions.route(
    {
      origin: new mapkit.Coordinate(pointA.lat, pointA.lng),
      destination: new mapkit.Coordinate(pointB.lat, pointB.lng),
      transportType: mapkit.Directions.Transport.Automobile,
      requestsAlternateRoutes: false
    },
    (error, data) => {
      if (error) return
      const route = data.routes[0]

      if (route?.polyline) {
        route.polyline.style = new mapkit.Style({
          strokeColor: '#000000',
          lineWidth: 4,
          lineCap: 'round',
          lineJoin: 'round',
          ...opts
        })
        onAddOverlays([route.polyline])
      }
    }
  )
}
